<app-selection-buttons-container
  [buttonsArrayBehaviorSubject]="environmentSelectionButtons"
  [title]="
    (inAddMode ? 'integrationPage.addModeEnvironmentField' : 'integrationPage.editModeEnvironmentField')
      | labelsProvider
  "
  (buttonOnClick)="onEnvironmentSelected($event)"
>
</app-selection-buttons-container>
